import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserModel } from '@data-layer/models/user';
import { INPUT_TYPES_MAP } from '@constants/input-types-map';
import { CompaniesService } from '@services/companies.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-verify-phone-number',
  templateUrl: './verify-phone-number.component.html',
  styleUrls: ['./verify-phone-number.component.scss'],
})
export class VerifyPhoneNumberComponent implements OnInit {
  @Input() public phone: string;
  @Output() public callback: EventEmitter<any> = new EventEmitter();
  public verifyCompleted: boolean = false;
  public code: any[] = [];
  public invalidCode: boolean = false;
  public integerInputMap: { mask: string; pattern: string } = INPUT_TYPES_MAP.INTEGER;
  public isOpenModal: boolean = false;
  private user: UserModel;

  constructor(private companiesService: CompaniesService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {}

  public openModal(number: string, user: UserModel) {
    this.phone = number;
    this.user = user;

    this.isOpenModal = true;
  }

  public onConfirm(): void {
    this.isOpenModal = false;
    // this.confirm.emit();
  }

  public onDecline(): void {
    this.isOpenModal = false;
    // this.decline.emit();
  }

  public resend(e: Event) {
    e.preventDefault();
    this.companiesService
      .phoneConfirmation(this.phone)
      .pipe(take(1))
      .subscribe(() => {});
  }

  public onKey(e: any) {
    const { id } = e.target;
    const value = e.key;
    if (value.match(/^\d+\.?\d*$/)) {
      this.code[id] = value;
    }
    if (e.keyCode === 8) {
      this.code[id] = '';
    }
  }

  public verifyPhone() {
    this.companiesService
      .confirmationPhoneCode(this.phone, this.code.join(''))
      .pipe(take(1))
      .subscribe((res: { valid: boolean }) => {
        if (res.valid) {
          this.verifyCompleted = true;
          this.user.phoneNumberConfirmed = true;
          this.cdr.markForCheck();
          this.companiesService
            .getUserData(true)
            .pipe(take(1))
            .subscribe(() => {
              this.callback.emit();
            });
        } else {
          this.invalidCode = true;
        }
      });
  }
}
